import {
  Button,
  Text,
  Card,
  Group,
  Modal,
  ActionIcon,
  CloseIcon,
  Container,
  CloseButton,
  Badge,
  Tooltip,
} from '@mantine/core';
import { Nuts } from '@src/types/maps';
import { useState } from 'react';
import CompareTable from '@components/nuts-compare-table';

interface NutsCompareProps {
  compareState: Nuts[];
  setCompareState: React.Dispatch<React.SetStateAction<Nuts[]>>;
  onMinimize?: () => void;
}

function NutsCompare({ compareState, setCompareState, onMinimize }: NutsCompareProps) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (compareState.length === 0) {
    return null;
  }

  // Clear to state to make the compare component disappear
  const clearCompareState = () => {
    setCompareState([]);
  };

  return (
    <Container
      p={10}
      style={{
        padding: '12px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        background: '#fff',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        maxWidth: 'min(1200px, 96vw)',
        width: 'auto',
      }}
    >
      <Group justify="space-between" preventGrowOverflow>
        <Text fw={700}>Selected for compare</Text>
        <Group gap="xs">
          <Button
            variant="filled"
            color="green"
            disabled={compareState.length < 2}
            onClick={() => setIsModalOpen(true)}
          >
            Run Compare
          </Button>
          <Button variant="outline" onClick={clearCompareState}>
            Clear
          </Button>
          <Tooltip label="Close" withArrow>
            <CloseButton aria-label="Minimize compare drawer" onClick={onMinimize} />
          </Tooltip>
        </Group>
      </Group>

      <Group justify="flex-start" mt="xs" wrap="wrap" gap="sm">
        {compareState.map((nut, index) => (
          <Card key={`${nut.nutsId}-${index}`} withBorder p="xs" pr={36} radius="md">
            <Badge color="blue" variant="filled" size="sm">
              {index + 1}
            </Badge>
            <Tooltip label="Remove" withArrow>
              <ActionIcon
                variant="transparent"
                onClick={() => setCompareState((prev) => prev.filter((_, i) => i !== index))}
                style={{ position: 'absolute', top: 4, right: 4 }}
                aria-label={`Remove ${nut.nutsName}`}
              >
                <CloseIcon />
              </ActionIcon>
            </Tooltip>
            <Text size="sm" maw={320} style={{ maxWidth: 320 }}>
              {nut.nutsName}, {nut.countryName}
            </Text>
          </Card>
        ))}
      </Group>

      <Modal opened={isModalOpen} onClose={() => setIsModalOpen(false)} size="55%">
        <CompareTable nutDestinations={compareState} />
        <Group justify="flex-end" mt={0}>
          <Button variant="outline" color="blue" mt={20} onClick={() => setIsModalOpen(false)}>
            Close
          </Button>
        </Group>
      </Modal>
    </Container>
  );
}

export default NutsCompare;
